// src/pages/AdminPelada.js
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "../components/Menu";
import AdminPeladaDetails from "../components/admpelada";
import Mensalistas from "../components/Mensalistas";
import api from "../api";
import "./AdminPelada.css";

const AdminPelada = () => {
  const { peladaId: groupId } = useParams();
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [loadingCount, setLoadingCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // ✅ memoiza para não mudar identidade a cada render
  const onStartLoading = useCallback(() => {
    setLoadingCount((prev) => prev + 1);
  }, []);
  const onFinishLoading = useCallback(() => {
    setLoadingCount((prev) => Math.max(prev - 1, 0));
  }, []);

  useEffect(() => {
    setLoading(loadingCount > 0);
  }, [loadingCount]);

  const handleDeleteGroup = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = { Authorization: `Bearer ${token}` };
      await api.delete(`/api/groups/${groupId}`, { headers });
      alert("Grupo excluído com sucesso!");
      navigate("/dashboard");
    } catch (err) {
      console.error("Erro ao excluir grupo:", err);
      setError(err?.response?.data?.error || "Erro ao excluir grupo.");
    }
  };

  return (
    <div className="admin-page">
      {/* Header fixo com reserva de espaço no CSS */}
      <div className="topbar">
        <Menu />
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="loader-spinner"></div>
          <p className="loader-text">Aguarde, carregando...</p>
        </div>
      )}

      <main className="admin-content">
        <header className="admin-head">
          <div>
            <h1 className="admin-title">Admin do Grupo</h1>
            <p className="admin-subtitle">Gerencie a próxima pelada, lista e mensalistas</p>
          </div>
          <div className="admin-actions">
            <button className="btn btn--ghost" onClick={() => navigate(-1)}>
              ⬅ Voltar
            </button>
          </div>
        </header>

        <section className="admin-grid">
          <div className="admin-card">
            <div className="card-head">
              <h2>Configuração & Sessão</h2>
            </div>
            <div className="card-body">
              <AdminPeladaDetails
                peladaId={groupId}
                onStartLoading={onStartLoading}
                onFinishLoading={onFinishLoading}
              />
            </div>
          </div>

          <div className="admin-card">
            <div className="card-head">
              <h2>Mensalistas</h2>
            </div>
            <div className="card-body">
              <Mensalistas
                peladaId={groupId}
                onStartLoading={onStartLoading}
                onFinishLoading={onFinishLoading}
              />
            </div>
          </div>
        </section>

        {/* Danger zone no final da página (confirmação tripla já enviada antes) */}
        <section className="danger-zone">
          <div className="danger-card">
            <h3 className="danger-title">Zona perigosa</h3>
            <p className="danger-desc">
              Excluir o grupo é uma ação <strong>permanente</strong>. Todos os dados relacionados
              serão removidos e não poderão ser recuperados.
            </p>
            {/* Abra aqui o seu modal de confirmação tripla, se estiver usando a versão com modal */}
            <button className="btn btn--danger" onClick={handleDeleteGroup}>
              Excluir Grupo
            </button>
          </div>
        </section>

        {error && <p className="error-message">{error}</p>}
      </main>
    </div>
  );
};

export default AdminPelada;
